import _ from "lodash";
import AthubCloudApi from "@/api/athubCloud";
import Dictionary from '../dictionary';
import DictionaryFactory from '../dictionary-factory';

export const DICTIONARY_FACTORY_ROOM = 'room';
export const DICTIONARY_FACTORY_ROOM_TYPE_AUTH_SITE = 'AUTH_SITE';
export const DICTIONARY_FACTORY_ROOM_TYPE_ALL = 'ALL';
export const DICTIONARY_FACTORY_ROOM_TYPE_AUTH_SITE_ALL = 'AUTH_SITE_ALL';
export default class RoomDictionaryFactory extends DictionaryFactory {
    constructor() {
        super({name: DICTIONARY_FACTORY_ROOM});
    }

    async getDictionary({type}) {
        let dictionary;
        switch (type) {
            case DICTIONARY_FACTORY_ROOM_TYPE_AUTH_SITE: {
                let rooms = await AthubCloudApi.getRoomsByAuthSites();
                dictionary = new Dictionary({items: rooms, valueKey: 'id', textKey: 'name'});
                break;
            }
            case DICTIONARY_FACTORY_ROOM_TYPE_ALL: {
                let rooms = await AthubCloudApi.fetchAllSysroomList();
                dictionary = new Dictionary({items: rooms, valueKey: 'id', textKey: 'name'});
                break;
            }
            case DICTIONARY_FACTORY_ROOM_TYPE_AUTH_SITE_ALL: {
                let authRooms = await AthubCloudApi.getRoomsByAuthSites();
                let allRooms = await AthubCloudApi.fetchAllSysroomList();
                let authRoomIds = _.map(authRooms, room => room.id);
                let allRoomIds = _.map(allRooms, room => room.id);
                let noAuthRoomIds = allRoomIds.filter(roomId => authRoomIds.indexOf(roomId) === -1);
                let noAuthRooms = allRooms.filter(room => noAuthRoomIds.indexOf(room.id) !== -1);
                authRooms.forEach(room => {
                    room.optionDisabled = false;
                });
                noAuthRooms.forEach(room => {
                    room.optionDisabled = true;
                });
                let rooms = authRooms.concat(noAuthRooms);
                dictionary = new Dictionary({items: rooms, valueKey: 'id', textKey: 'name'});
                break;
            }
        }
        if (dictionary == null) {
            dictionary = new Dictionary({items: []});
        }
        return dictionary;
    }
}